import React from "react";

export default function AvatarModal({ avatarZoom, onClose }) {
  if (!avatarZoom) return null;

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-[9999] bg-black flex items-center justify-center"
    >
      {/* Header Layer */}
      <div className="absolute inset-x-0 top-0 z-20 flex items-center justify-between p-4">
        
        {/* Name */}
        <div>
          {avatarZoom.name && (
            <span className="text-white bg-black/50 px-4 py-1 rounded-full text-sm">
              {avatarZoom.name}
            </span>
          )}
        </div>

        {/* Close */}
        <button
          onClick={onClose}
          className="w-10 h-10 rounded-full bg-black/70 text-white text-xl flex items-center justify-center"
        >
          ×
        </button>
      </div>

      {/* Content */}
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative flex items-center justify-center"
      >
        {avatarZoom.image ? (
          <div className="w-[90vw] max-w-md aspect-square">
            <img
              src={avatarZoom.image}
              className="w-full h-full object-cover rounded-xl"
              alt={avatarZoom.name || "Avatar"}
            />
          </div>
        ) : (
          <div className="w-64 h-64 bg-neutral-700 flex items-center justify-center text-white text-7xl rounded-full">
            {avatarZoom.type === "group" ? "👥" : "👤"}
          </div>
        )}
      </div>
    </div>
  );
}